import { User } from '@module/user';
import { RootReducerState } from 'redux/root.reducer';

export const userSelector = (state: RootReducerState): User => state.pageLayout.userResponse;

export const signOutStatusSelector = (state: RootReducerState): number =>
  state.pageLayout.signOutStatus;

export const getUserByIdStatusSelector = (state: RootReducerState): number =>
  state.pageLayout.getUserByIdStatus;

export const getTestMakerLocaleStatusSelector = (state: RootReducerState): number =>
  state.pageLayout.getTestMakerLocaleStatus;

export const changeTestMakerLocaleStatusSelector = (state: RootReducerState): number =>
  state.pageLayout.changeTestMakerLocaleStatus;

export const currentLocaleSelector = (state: RootReducerState): string | null =>
  state.pageLayout.currentLocale;
